import { omit } from 'lodash'
import { IEvent } from '../../../models/Event'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: { event: IEvent },
): IBookingCalendarStore {
  return {
    ...state,
    eventLabels: omit(state.eventLabels, [action.event.id]),
  }
}
